import React from "react";
const ProgressOverlayContext = React.createContext({});
ProgressOverlayContext.displayName = "ProgressOverlayContext";
export default ProgressOverlayContext;
